import HorizontalScroll from "@Components/HorizontalScroll";
import Subsection from "../Subsection";
import styles from "./ThreeStepsSection.module.scss";
import StepCard from "./components/StepCard";
import { REFERRAL_PAGE_STATIC_URL } from "constants/index";
import useIsDesktop from "hooks/useIsDesktop";
import wrapperHOC from "@Utils/wrapperHOC";
import { BASE_IMG_URL } from "constants/configConstants";
import TermsAndConditionDesktop from "@Pages/Referral/Desktop/Components/TermsAndConditionDesktop";
import useTranslationHook from "hooks/useTranslationHook";

const ThreeStepsSection = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslationHook();

  return (
    <>
      <Subsection
        title={t("referral.steps.title")}
        subtitle=""
        withSidePadding
        titleH2
        greyBg={false}
      >
        <HorizontalScroll className={styles.horizontalScroll} showControls={isDesktop}>
          <StepCard
            stepNumber={1}
            imgSrc={`${BASE_IMG_URL}/booking-step-1-new.svg`}
            title={t("referral.steps.share.title")}
            subTitle={t("referral.steps.share.subtitle")}
            showArrow
          />
          <StepCard
            stepNumber={2}
            imgSrc={`${REFERRAL_PAGE_STATIC_URL}/bookings-steps-hd-3.svg`}
            title={t("referral.steps.book.title")}
            subTitle={t("referral.steps.book.subtitle")}
            showArrow
          />
          <StepCard
            stepNumber={3}
            imgSrc={`${BASE_IMG_URL}/booking-step-3-new.svg`}
            title={t("referral.steps.earn.title")}
            subTitle={t("referral.steps.earn.subtitle")}
          />
        </HorizontalScroll>
      </Subsection>
      <TermsAndConditionDesktop />
    </>
  );
};

export default wrapperHOC(ThreeStepsSection, {
  componentName: "ThreeStepsSection-Referral",
  showForChina: true,
});
